var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.646 0C10.7855 0 9.99653 0.27269 9.30111 0.810513C8.63441 1.32613 8.19053 1.98286 7.9292 2.46041C7.66788 1.98283 7.224 1.32613 6.5573 0.810513C5.86188 0.27269 5.07292 0 4.21239 0C1.81096 0 0 1.96424 0 4.56902C0 7.38308 2.2593 9.30842 5.67957 12.2231C6.26039 12.7181 6.91873 13.2792 7.60299 13.8775C7.69319 13.9565 7.80903 14 7.9292 14C8.04938 14 8.16522 13.9565 8.25542 13.8776C8.93974 13.2791 9.59805 12.7181 10.1792 12.2228C13.5991 9.30842 15.8584 7.38308 15.8584 4.56902C15.8584 1.96424 14.0475 0 11.646 0Z",
    fill: "#406EE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteBlue);
export default __webpack_public_path__ + "static/media/vote_blue.9b46591a4e9b501818e66e378b8a65de.svg";
export { ForwardRef as ReactComponent };